import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { InvoiceTaskFileEditForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm';

export const InvoiceTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`請求書等ファイル一覧`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
        { label: `プロジェクト（売上）詳細`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}` },
        {
          label: `請求タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}/invoice_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();
  const { invoiceTask: task } = useCurrentInvoiceTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <InvoiceTaskFileEditForm />
    </WorkspaceLayout>
  );
};
